import React from 'react'
import Radio from '../Radio/Radio'
import { RadioGroupProps } from './RadioGroup.types'
import useInput from '../useInput'
import InputWrapper from '../InputWrapper/InputWrapper'
import Label from '../Label/Label'

const RadioGroup: React.FC<RadioGroupProps> = (props) => {
    const context = useInput({ ...props })
    const { value, isDisabled, onChange } = context

    const handleSelect = (e) => {
        onChange(e.currentTarget.value)
    }

    const classNames = () => {
        const c = ['r-radio-group-container']

        if (value) {
            c.push('r-state-checked')
        }
        if (isDisabled) {
            c.push('r-state-disabled')
        }

        if (props.horizontal) {
            c.push('r-display-horizontal')
        }

        return c.join(' ')
    }

    const renderRadios = () => {
        return props.options.map((option, i) => {
            return (
                <Radio
                    key={i}
                    {...option}
                    name={props.name}
                    onChange={handleSelect}
                    defaultChecked={value === option.value}
                />
            )
        })
    }

    return (
        <InputWrapper {...context}>
            <div data-testid='RadioGroup' className={classNames()}>
                {renderRadios()}
            </div>
        </InputWrapper>
    )
}

export default RadioGroup
